import React from 'react'

export default function Productivity() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.7019 4.7019V55.2983H55.2983" stroke="url(#paint0_linear_3171_3618)" strokeOpacity="0.8" strokeWidth="3.43" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.3739 17.4827C24.277 17.4827 27.4409 20.6467 27.4409 24.5497C27.4409 28.4527 24.277 31.6168 20.3739 31.6168C16.4709 31.6168 13.3069 28.4527 13.3069 24.5497C13.3069 20.6467 16.4709 17.4827 20.3739 17.4827Z" stroke="url(#paint1_linear_3171_3618)" strokeOpacity="0.8" strokeWidth="3.43" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M48.2303 5.6687C52.133 5.6687 55.297 8.83273 55.297 12.7357C55.297 16.6388 52.133 19.8028 48.2303 19.8028C44.3272 19.8028 41.1631 16.6388 41.1631 12.7357C41.1631 8.83273 44.3272 5.6687 48.2303 5.6687Z" stroke="url(#paint2_linear_3171_3618)" strokeOpacity="0.8" strokeWidth="3.43" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M38.4059 31.6167C42.3089 31.6167 45.473 34.7807 45.473 38.6838C45.473 42.5867 42.3089 45.7508 38.4059 45.7508C34.5029 45.7508 31.3389 42.5867 31.3389 38.6838C31.3389 34.7807 34.5029 31.6167 38.4059 31.6167Z" stroke="url(#paint3_linear_3171_3618)" strokeOpacity="0.8" strokeWidth="3.43" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.70093 39.6464L14.7856 28.877" stroke="url(#paint4_linear_3171_3618)" strokeOpacity="0.8" strokeWidth="3.43" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M26.5374 28.0725L33.004 34.1039" stroke="url(#paint5_linear_3171_3618)" strokeOpacity="0.8" strokeWidth="3.43" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M41.5227 32.3006L46.1862 19.4917" stroke="url(#paint6_linear_3171_3618)" strokeOpacity="0.8" strokeWidth="3.43" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_3171_3618" x1="30.0001" y1="4.7019" x2="30.0001" y2="55.2983" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint1_linear_3171_3618" x1="20.3739" y1="17.4827" x2="20.3739" y2="31.6168" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint2_linear_3171_3618" x1="48.2301" y1="5.6687" x2="48.2301" y2="19.8028" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint3_linear_3171_3618" x1="38.4059" y1="31.6167" x2="38.4059" y2="45.7508" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint4_linear_3171_3618" x1="9.74327" y1="28.877" x2="9.74327" y2="39.6464" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint5_linear_3171_3618" x1="29.7707" y1="28.0725" x2="29.7707" y2="34.1039" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
        <linearGradient id="paint6_linear_3171_3618" x1="43.8545" y1="19.4917" x2="43.8545" y2="32.3006" gradientUnits="userSpaceOnUse">
          <stop stopColor="#232431" />
          <stop offset="0.335" stopColor="#3A3D54" />
        </linearGradient>
      </defs>
    </svg>
  )
}
